import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=1cfb2447"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&id=1cfb2447&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cfb2447')) {
      api.createRecord('1cfb2447', component.options)
    } else {
      api.reload('1cfb2447', component.options)
    }
    module.hot.accept("./ProfileDropdown.vue?vue&type=template&id=1cfb2447", function () {
      api.rerender('1cfb2447', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-navbar/components/dropdowns/ProfileDropdown.vue"
export default component.exports